import {
  BenefitSplitLimits,
  BonusHistory,
  BonusStatus,
  ForemanPromocode,
  ForemanPromocodesList,
  PersonalManager,
  PersonalManagersList,
  SearchOrderDocumentResult,
} from '@my-account/const';
import { StateUtils } from '@spartacus/core';

export const MY_ACCOUNT_FEATURE = 'myAccount';
export const SEARCH_ORDER_DOCUMENT_ENTITY = '[MyAccount] Order Document Search Entity';
export const PERSONAL_MANAGER_CONFIRMATION = '[MyAccount] Confirmation Manager';
export const PERSONAL_MANAGERS_LIST = '[MyAccount] Personal Managers List';
export const ACCEPT_MANAGER = '[MyAccount] Accept Manager';
export const REVOKE_MANAGER = '[MyAccount] Revoke Manager';
export const DELETE_MANAGER = '[MyAccount] Delete Manager';
export const BONUS_HISTORY = '[MyAccount] Bonus history';
export const BONUS_STATUS = '[MyAccount] Bonus status';
export const BENEFIT_SPLIT_LIMITS = '[MyAccount] Benefit Split Limits';
export const GENERATED_PROMOCODE = '[MyAccount] Generated Promocode';
export const FOREMAN_PROMOCODES_LIST = '[MyAccount] Foreman Promocodes List';

export interface StateWithMyAccount {
  [MY_ACCOUNT_FEATURE]: MyAccountState;
}

export interface MyAccountState {
  orderDocument: {
    search: StateUtils.LoaderState<SearchOrderDocumentResult>;
  };
  personalManagerConfirmation: StateUtils.LoaderState<PersonalManager>;
  approveManager: StateUtils.EntityLoaderState<string>;
  revokeManager: StateUtils.EntityLoaderState<string>;
  deleteManager: StateUtils.EntityLoaderState<string>;
  personalManagersList: StateUtils.LoaderState<PersonalManagersList>;
  bonusHistory: StateUtils.LoaderState<BonusHistory>;
  bonusStatus: StateUtils.LoaderState<BonusStatus>;
  foremanPromocodes: {
    benefitSplitLimits: StateUtils.LoaderState<BenefitSplitLimits>;
    generatedPromocode: StateUtils.LoaderState<ForemanPromocode>;
    list: StateUtils.LoaderState<ForemanPromocodesList>;
  };
}
